
<div class="filter-dialog-container">
  <loading [isLoading]="isLoading"></loading>
  <div class="header-panel">
    <div class="btnClose">
      <img [src]="'cancelar.svg' | findUrl" (click)="cancel()">
    </div>
    <h3>Buscar por:</h3>
    <div style="flex-basis: 10%;"></div>
  </div>

  <div class="dialog-content-container">
    <form [formGroup]="form" fxLayout="column" xLayoutAlign="space-around none" >
      
      <div class="filter-flex">
        <div *ngFor="let filter of filters" style="display: flex; flex-direction: column;">
          <label >{{filter.key}}</label>

          <app-filter-map-autocomplete class="filter-item col-12"
          [filter]="filter"
          [selected]="filter.selected" 
          [form] = "form"
          (onOptionSelected)="addFilter($event)"
          (onOptionDeleted)="dropFilter($event)">
        </app-filter-map-autocomplete>
        
        </div>
      </div>
    </form>
  </div>

  <div class="dialog-actions-container">
    <!-- <button mat-button (click)="cancel()">Cerrar</button> -->
    <button mat-button *ngIf="valuesFiltered.length > 0" (click)="clear()" class="btnClean">Limpiar</button>
    <button mat-button (click)="accept()" class="btnAccept">Buscar</button>
  </div>
</div>
